import React, { useRef, useState } from 'react';
import { ClickAwayListener, Paper, Popper } from '@mui/material';
import { AvColorPicker } from './AvColorPicker';
import { ColorItem } from './ColorItem';

interface AvColorPickerPopperProps {
  hexCode: string;
  onChangeHexCode: (v: string) => void;
}

export const AvColorPickerPopper: React.FC<AvColorPickerPopperProps> = ({ hexCode, onChangeHexCode }) => {
  const anchorEl = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);

  return (
    <>
      <ColorItem ref={anchorEl} item={hexCode} isActive={open} onClick={() => setOpen(true)} />
      <Popper open={open} anchorEl={anchorEl.current} placement="bottom-start" sx={{ zIndex: theme => theme.zIndex.modal }}>
        <ClickAwayListener onClickAway={() => open && onClose()}>
          <Paper sx={{ boxShadow: 'unset' }}>
            <AvColorPicker hexCode={hexCode} onChangeHexCode={onChangeHexCode} />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};
